import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FormField = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: 28,
  backgroundColor: "#fff",
  marginLeft: "2px",
  borderRadius: "2px 0 0 2px",
  width: 230,
  "& .MuiInputBase-input": {
    padding: 0,
    fontSize: theme.typography.size.normal,
  },
}));

export const VersionChip = styled(Chip)(({ theme }) => ({
  backgroundColor: "#EBF6FF",
  color: theme.palette.biarri.secondary.activeBlue,
  height: 20,
}));
